import type { BranchPredicateConfig } from '@onefootprint/request-types/dashboard';

const getBranch = (
  branchOn: BranchPredicateConfig['identifier'] | undefined | null,
  config?: BranchPredicateConfig[],
) => {
  if (!config?.length || !branchOn) return null;
  return config.find(c => c.identifier === branchOn);
};

export default getBranch;
